import $ from 'jquery';
window.jQuery = $;
window.$ = $;
global.jQuery = $;
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap'
import 'animate.css'


import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Fragment from 'vue-fragment'
import axios from 'axios'
import VueAxios from 'vue-axios'
import UUID from "vue-uuid";
import moment from 'moment'

Vue.use(Fragment.Plugin)
Vue.use(VueAxios, axios)
Vue.use(UUID);
Vue.prototype.moment = moment

Vue.config.productionTip = false

Vue.filter('s3url', function (value, key) {
    if (value) {
        if (key) {

            if (key == "") {
                key = "file";
            }
            else {
                key = key + "File";
            }

            var file = value[key];
            var fileName = value[key + "Name"];
            if (file && (file instanceof Blob || file instanceof File)) {
                debugger;
                return URL.createObjectURL(file);
            } else if (fileName) {
                return "https://fabricfour.blob.core.windows.net/mhslearning-upload/" + fileName;
            }
        }
        else if (value.file) {
            //if this object has a file object attached to it, it must be a new file property
            var url = URL.createObjectURL(value.file);
            console.log("Created url", url);
            return url;

        } else if (value.fileName) {
            //if it has a fileName
            return "https://fabricfour.blob.core.windows.net/mhslearning-upload/" + value.fileName;

        } else if (value.imageFile) {
            //if this object has a file object attached to it, it must be a new file property
            return URL.createObjectURL(value.imageFile);

        } else if (value.imageFileName) {
            //if it has a fileName
            return "https://fabricfour.blob.core.windows.net/mhslearning-upload/" + value.imageFileName;

        } else if (value.profileFileName) {
            //if this object has a file object attached to it, it must be a new file property
            return "https://fabricfour.blob.core.windows.net/mhslearning-upload/" + value.profileFileName;
        }
        else if (value.length) {
            //probably a filename then?
            return "https://fabricfour.blob.core.windows.net/mhslearning-upload/" + value;
        }
    }

    return null;
});


import CourseCardComponent from './components/CourseCardComponent'
Vue.component('course-card-component', CourseCardComponent)

import CoursePackageComponent from './components/CoursePackageComponent'
Vue.component('course-package-component', CoursePackageComponent)

//COURSE DETAILS
import RichTextComponent from "./components/RichTextComponent";
Vue.component('rich-text-component', RichTextComponent)
import CourseNameHeader from './components/CourseDetails/CourseNameHeader';
Vue.component('course-name-header', CourseNameHeader)
import CourseImageHeader from './components/CourseDetails/CourseImageHeader';
Vue.component('course-image-header', CourseImageHeader)
import CourseActions from './components/CourseDetails/CourseActions';
Vue.component('course-actions', CourseActions)
import CourseContents from './components/CourseDetails/CourseContents';
Vue.component('course-contents', CourseContents)
import SideMenu from './components/CourseDetails/SideMenu';
Vue.component('side-menu', SideMenu)
import CourseInfo from './components/CourseDetails/CourseInfo';
Vue.component('course-info', CourseInfo)
import PageTitle from './components/CourseDetails/PageTitle';
Vue.component('page-title', PageTitle)
import ComponentList from './components/CourseDetails/ComponentList';
Vue.component('component-list', ComponentList)
import StudentsPage from './components/CourseDetails/StudentsPage';
Vue.component('students-page', StudentsPage)
import AttendeesPage from './components/CourseDetails/AttendeesPage';
Vue.component('attendees-page', AttendeesPage)
import CouponsPage from './components/CourseDetails/CouponsPage';
Vue.component('coupons-page', CouponsPage)
import CertificatePage from './components/CourseDetails/CertificatePage';
Vue.component('certificate-page', CertificatePage)
import ContentDisplay from './components/CourseDetails/ContentDisplay';
Vue.component('content-display', ContentDisplay)



import ConditionalText from './components/CourseDetails/ConditionalText';
Vue.component('conditional-text', ConditionalText)
import EditSwitch from './components/CourseDetails/EditSwitch';
Vue.component('edit-switch', EditSwitch)
import CertificateProperty from './components/CourseDetails/CertificateProperty';
Vue.component('certificate-property', CertificateProperty)
import CertificateActions from './components/CourseDetails/CertificateActions';
Vue.component('certificate-actions', CertificateActions)
import CertificateFields from './components/CourseDetails/CertificateFields';
Vue.component('certificate-fields', CertificateFields)

import mixinsWebRequests from "./mixinsWebRequests";
Vue.mixin(mixinsWebRequests);

import mixinsValidation from "./mixinsValidation";
Vue.mixin(mixinsValidation);

const vm = new Vue({
    router,
    render: h => h(App),
    store,
    mounted: function () {

        //load user state from localStorage
        this.$store.commit("loadUserState"); 
    }
});

vm.$mount('#app');
